import * as React from 'react';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';

//Components, Styles, State, Images
import styles from '../Descriptions/Descriptions.module.scss';
import { Divider } from '@mui/material';

type DescriptionModals = {
    topic: any,
    obj: any
};

interface DescriptionsList {
    descriptionsList: any[],
    pickedTopics: any[]
};

//Functional component responsible for displaying descriptions specific to props.topic
function DescriptionModal ({ topic, obj }: DescriptionModals) {
    let titleId = topic.value + '-title';
    let modalId = topic.value + '-modal';

    const [open, setOpen] = React.useState(false);
    // const [open, setOpen] = useState<any[]>([]);

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    let body = (
        <div>
            <h2 id={titleId}>{topic.value}</h2>
            <Divider />
            <p id={modalId}>{obj.description}</p>
        </div>
    );

    return(
        <div className={styles.tooltip}>
            <Button onClick={handleOpen} className={styles.button}>{topic.value}<br />{'Last Updated: ' + obj.lastupdated}</Button>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby={titleId}
                    aria-describedby={modalId}
                >
                <div className={styles.paper}>{body}</div>
            </Modal>
        </div>
    )
};

//Base component responsible for holding the list of DescriptionModal components, represented as buttons in the description panel
export default function Descriptions (props: DescriptionsList) {
    const { descriptionsList, pickedTopics } = props;
     return (
        <> 
            { pickedTopics.map( topic => {
                let obj = descriptionsList.find(o => o.topic === topic.value);
                return (
                <>
                    {<DescriptionModal topic={topic} obj={obj} key={topic.value}/>}
                </>
            )})} 
        </>
    );
};
